<app-card-item
  [baseData]="baseData"
  [issueDate]="issueDate"
  [viewMode]="viewMode"
  [showPublicationDate]="showPublicationDate"
  (actionNavigate)="navigateResultsSection.emit()">
  <ng-template appButtonPanel>
    <app-rating
      class="interactions__rating"
      [rating]="rating"
      [recordId]="record.id"
      [record]="record"
      [readOnly]="readOnly"
      appStopPropagation>
    </app-rating>

    <ng-container *ngIf="record?.wishListInfo; else defaultPanel">
      <button
        mat-flat-button
        appStopPropagation
        class="only-icon hide-mobile"
        *ngIf="!list?.privateList"
        (keydown.space)="copyListLinkToClipboard()"
        (keydown.enter)="copyListLinkToClipboard()"
        (click)="copyListLinkToClipboard()"
        [opacTooltip]="'tooltip.copyLink' | translate"
        [attr.aria-label]="'tooltip.copyLink' | translate">
        <span class="odilo-icon">link</span>
      </button>
    </ng-container>
    <ng-template #defaultPanel>
      <app-favorite-button [record]="record" appStopPropagation> </app-favorite-button>
      <app-more-option-button [recordItem]="record"></app-more-option-button>
    </ng-template>
  </ng-template>

  <ng-template appRecordButtons>
    <app-record-buttons
      from="RESULT_SCREEN"
      [record]="record"
      [config]="buttonsConfig"
      [issueDate]="issueDate"
      [callback]="toggleShowGallery"
      appStopPropagation>
    </app-record-buttons>
    <ng-container *ngIf="images?.length">
      <app-image-gallery from="RESULT_SCREEN" [images]="images" [recordId]="record.id" [placeholder]="false" #gallery>
      </app-image-gallery>
    </ng-container>
    <span
      *ngIf="record?.description"
      class="description"
      [ellipsis]="2"
      [innerHTML]="record?.description"></span>
  </ng-template>
</app-card-item>
